import React, { Component } from 'react';
import Switch from 'react-switch';

class Checkbox extends Component {
  state = {
    checked: false,
  };

  componentDidMount() {
    const { checked } = this.props;
    this.setState({ checked });
  }

  componentDidUpdate(oldProps) {
    const { checked } = this.props;

    if (oldProps.checked !== checked) {
      this.setState({ checked });
    }
  }

  handleChange = () => {
    const { checked } = this.state;
    const { onChange } = this.props;

    this.setState({ checked: !checked });

    onChange();
  };

  render() {
    const { checked } = this.state;

    return (
      <Switch
        onChange={this.handleChange}
        checked={checked ? true : false}
        checkedIcon={false}
        uncheckedIcon={false}
        className={`checkbox-switch ${!checked && 'checkbox-switch-off'}`}
        height={20}
        width={45}
        handleDiameter={12}
        {...this.props}
      />
    );
  }
}

export default Checkbox;
